<ng-container *ngIf="dialogRef">
  <div class="app-dialog">
    <header class="app-dialog__header">
      <div class="app-dialog__header-text">
        <h2>{{ 'tutorial.title' | translate }}</h2>
      </div>
      <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="app-dialog__body">
      <p class="tutorial-description">{{ 'tutorial.description' | translate }}</p>
      <div class="video-container">
        <iframe
          [src]="videoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>
      </div>
    </div>

    <footer class="app-dialog__footer">
      <button mat-stroked-button type="button" (click)="close()">
        {{ 'close' | translate }}
      </button>
    </footer>
  </div>
</ng-container>
